<template>
  <div class="TlDeskRange" :class="modifiers">
    <div class="TlDeskRange-text" @click="handleClick">
      {{ rangeText }}
    </div>
    <div class="TlDeskRange-bounds">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    range: Object,
    active: Boolean,
  },
  methods: {
    handleClick() {
      if (!this.active) this.$emit("range-click");
    },
  },
  computed: {
    modifiers() {
      return this.active ? "TlDeskRange--active" : undefined;
    },
    rangeText() {
      const [yearA, yearB] = this.range.yearRange;
      return `${yearA} - ${yearB}`;
    },
  },
};
</script>

<style lang="stylus">
@import './TlDeskRange.styl';
</style>
